import React from "react";
import { motion } from "framer-motion";
import { STANDARDS } from "@/data/services";
import { SectionHead } from "./SectionHead";

const GRID_INITIAL = { opacity: 0, y: 14 };
const GRID_INVIEW = { opacity: 1, y: 0 };
const GRID_VIEWPORT = { once: true };
const GRID_T = { duration: 0.6 };

export const Standards = () => {
  return (
    <section id="standards" data-testid="standards-section" className="py-20 lg:py-24 bg-[#04162E] text-white">
      <div className="mx-auto max-w-[1180px] px-5 lg:px-8">
        <SectionHead
          dark
          no="02"
          label="Framework"
          title="Built on recognized standards"
          sub="Every engagement is grounded in the codes and consensus standards that govern high-hazard process industries — not house methodology invented to look proprietary."
        />

        <motion.div
          initial={GRID_INITIAL}
          whileInView={GRID_INVIEW}
          viewport={GRID_VIEWPORT}
          transition={GRID_T}
          className="grid grid-cols-2 md:grid-cols-3 border border-white/[0.14]"
        >
          {STANDARDS.map((s, i) => (
            <div
              key={s.code}
              data-testid={`standard-${i}`}
              className="p-6 md:p-7 border-b border-white/[0.14] border-r odd:border-r md:[&:nth-child(3n)]:border-r-0 even:border-r-0 md:even:border-r"
            >
              <div className="font-display text-[17px] font-bold text-[#0E8A57] mb-2">{s.code}</div>
              <div className="font-body text-[13.5px] text-[#C7D1DC]">{s.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
